export const DO_ACCEPTRESERVATION_START = "DO_ACCEPTRESERVATION_START";
export const DO_ACCEPTRESERVATION_SUCCESS = "DO_ACCEPTRESERVATION_SUCCESS";
export const DO_ACCEPTRESERVATION_FAILURE = "DO_ACCEPTRESERVATION_FAILURE";

export const ACCEPTED = 'ACCEPTED';
export const DECLINED = 'DECLINED';